import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


const __default__ = {
  name: 'IconComponent',
};

import { computed, useSlots, h } from 'vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  position: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  size: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {

const props = __props



const slots = useSlots();
const render = () => slots.default ? h(slots.default, null) : props.icon;

const getWidth = computed(() => props.size
  ? { width: typeof props.size === 'number' ? `${props.size}px` : props.size }
  : undefined);

const getPosition = computed(() => {
  if (!props.position) { return ''; }
  if (props.position === 'right') {
    return 'icon--right';
  }

  return 'icon--left';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["material-icons icon icon-component", _unref(getPosition)]),
    style: _normalizeStyle(_unref(getWidth))
  }, [
    _createVNode(render)
  ], 6))
}
}

})